import { getVariants } from "./allocation";
import { ExperimentConfig } from "./types/config";

export const experiments = {
  // CHECKOUT ------------------------------------------------------------------
  "abtest_drl_3749-dba_1": {
    description: "Remove loyalty card login",
    variants: getVariants(["A-control", "B-remove"] as const),
    domain_and_index: "abtest_name_dba_1",
    formula: {
      gamma_nl: true,
      gamma_be: true,
      karwei_nl: true,
    },
  },
  "abtest_dba_3461-dba_2": {
    description: "Free store delivery text",
    variants: getVariants(["A-control", "B-new"] as const),
    domain_and_index: "abtest_name_dba_2",
    formula: {
      gamma_nl: true,
      gamma_be: true,
      karwei_nl: true,
    },
  },
  "abtest_dba_2650_2-dba_3": {
    description: "Soft login wall",
    variants: getVariants(["A-control", "B-login"] as const),
    domain_and_index: "abtest_name_dba_3",
    formula: {
      gamma_nl: true,
      gamma_be: true,
      karwei_nl: true,
    },
  },
  "abtest_server_side-dba_5": {
    description: "Server side A/B test",
    variants: getVariants(["A-control", "B-variant"] as const),
    domain_and_index: "abtest_name_dba_5",
    formula: {
      gamma_nl: true,
      gamma_be: true,
      karwei_nl: true,
    },
  },

  // MYACCOUNT -----------------------------------------------------------------
  "abtest_drl_3343-drl_1": {
    description:
      "Reward commercial optin for EXISTING accounts with 500 loyalty points",
    variants: getVariants(["A-control", "B-snackbar"] as const),
    domain_and_index: "abtest_name_drl_1",
    formula: {
      gamma_nl: true,
      gamma_be: false,
      karwei_nl: false,
    },
  },
  "abtest_drl_3723-drl_2": {
    description: "Show unsubscribe text in sign-up newsletter optin",
    variants: getVariants(["A-control", "B-unsubscribe"] as const),
    domain_and_index: "abtest_name_drl_2",
    formula: {
      gamma_nl: true,
      gamma_be: true,
      karwei_nl: true,
    },
  },

  // SHOPFRONT -----------------------------------------------------------------
} as const satisfies ExperimentConfig;
